import { SxProps } from '@mui/system';

export const listStyles: SxProps = {
	listStyle: 'auto',
};

export const listItemStyles: SxProps = {
	display: 'list-item',
};
